import React from 'react';
import { NavLink } from 'react-router-dom';
import schickLogoWhite from '../resources/images/schick-logo-white.png';
import {
  CalendarIcon, CheckIcon, DownloadIcon, FlagIcon, HomeIcon, ImageIcon, KeyIcon, LogoutIcon, MegaphoneIcon,
  MusicIcon, PulseIcon, TasksIcon, UsersIcon, WandIcon,
} from './icons';

/**
 * The navigation, grouped by what one does: what is waiting first, then the content, the
 * hosts, the community and the system. The to-do entries carry how much is waiting.
 */
export const NAV_GROUPS = (counts, advertising) => [
  { items: [{ to: '/', end: true, label: 'Übersicht', icon: HomeIcon }] },
  {
    label: 'Zu erledigen',
    items: [
      { to: '/pending-events', label: 'Freigaben', icon: CheckIcon, count: counts?.approvals },
      { to: '/data-quality', label: 'Datenqualität', icon: WandIcon, count: counts?.proposals },
      { to: '/image-rights', label: 'Bildrechte', icon: ImageIcon, count: counts?.rightsTask },
      { to: '/issues', label: 'Meldungen', icon: FlagIcon, count: counts?.openIssues },
      { to: '/tasks', label: 'Aufgaben', icon: TasksIcon, count: counts?.teamDue },
    ],
  },
  {
    label: 'Inhalte',
    items: [
      { to: '/events', label: 'Events & Clubs', icon: CalendarIcon },
      { to: '/artists', label: 'Künstler', icon: MusicIcon },
      { to: '/material', label: 'Material', icon: DownloadIcon },
      ...(advertising ? [{ to: '/advertisement', label: 'Werbung', icon: MegaphoneIcon }] : []),
    ],
  },
  { label: 'Veranstalter', items: [{ to: '/host-codes', label: 'Host-Zugänge', icon: KeyIcon }] },
  { label: 'Community', items: [{ to: '/profile-pictures', label: 'Profilbilder', icon: UsersIcon }] },
  { label: 'System', items: [{ to: '/monitoring', label: 'Monitoring', icon: PulseIcon }] },
];

export default function Sidebar({ counts, advertising, userName, onLogout, onNavigate }) {
  const initial = (userName || 'A').trim().charAt(0).toUpperCase();
  return (
    <aside className="sidebar" aria-label="Navigation">
      <NavLink to="/" className="sidebar__brand" onClick={onNavigate}>
        <span className="sidebar__logo"><img src={schickLogoWhite} alt="" /></span>
        <span className="sidebar__brand-text"><strong>Schick</strong><span>Admin</span></span>
      </NavLink>
      <nav className="sidebar__nav">
        {NAV_GROUPS(counts, advertising).map((group, index) => (
          <div className="sidebar__group" key={group.label || index}>
            {group.label && <p className="sidebar__group-label">{group.label}</p>}
            {group.items.map(({ to, end, label, icon: Icon, count }) => (
              <NavLink key={to} to={to} end={end} onClick={onNavigate}
                className={({ isActive }) => 'sidebar__link' + (isActive ? ' active' : '')}>
                <Icon />
                <span className="sidebar__link-label">{label}</span>
                {count > 0 && <span className="sidebar__count" aria-label={`${count} offen`}>{count}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="sidebar__foot">
        <span className="sidebar__avatar" aria-hidden="true">{initial}</span>
        <span className="sidebar__user">{userName || 'Admin'}</span>
        <button type="button" className="sidebar__logout" onClick={onLogout}>
          <LogoutIcon /> Abmelden
        </button>
      </div>
    </aside>
  );
}
